import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';

import { perimenopauseCardsData } from '../_data/perimenopauseCardsData';

const PerimenopauseCards = () => {
  return (
    <section className="mb-20 lg:py-10" data-cy="perimenopause-cards">
      <LandingPageCards rounded="3xl" cards={perimenopauseCardsData} />
    </section>
  );
};

export default PerimenopauseCards;
